import React from 'react';
import { useWindowDimensions } from 'react-native';
import ActivateAccountWidget from '@eCommerce/legacy-activate-account-widget';
import styled from 'styled-components/native';
import { createGlobalStyle } from 'styled-components';

const WidgetContainer = styled.View<{ size: number }>`
  ${(props) => {
    if (props.size > 600) {
      return 'height: 100vh;';
    }
  }}
`;

const GlobalStyle = createGlobalStyle`
  body {
    background-color: #f7f7f8;
  }
`;

const ActivateAccount: React.FC = (): JSX.Element => {
  const width = useWindowDimensions().width;
  return (
    <WidgetContainer size={width}>
      <GlobalStyle />
      <ActivateAccountWidget clearMsgURL="/myrewards/profile/activateaccount" />
    </WidgetContainer>
  );
};

export default ActivateAccount;
